// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* 본문 섹션 */
 .greeting-section {
   padding: 60px;
 }

 .section-container {
   display: flex;
   gap: 60px;
   max-width: 1100px;
   margin: 0 auto;
 }

 /* 왼쪽 (스티키) */
 .greeting-section .left {
   flex: 1;
   position: sticky;
   top: 100px;
   align-self: flex-start;
 }

 .greeting-section h2 {
   font-size: 36px;
   font-weight: 900;
   margin-bottom: 20px;
 }

 .intro {
   font-size: 18px;
   font-weight: 600;
   line-height: 1.8;
 }

 /* 오른쪽 (스크롤 내용) */
 .right {
   flex: 2;
 }

 .greeting-section .ceo-info {
   display: flex;
   gap: 40px;
   margin-bottom: 16px;
   margin-right: 24px;
   float: left;

 }

 .greeting-section .person {
   display: flex;
   flex-direction: column;
   text-align: center;
   align-items: center;
 }

 .greeting-section .person p {
   font-weight: bold;
   margin-bottom: 10px;
   text-align: center;

 }

 .greeting-section .person img {
   max-width: 150px;
   border-radius: 100px;
   display: block;
   margin: 0 auto;
 }

 /* 본문 텍스트 */
 .greeting-section .content p {
   font-size: 16px;
   line-height: 1.9;
   text-align: justify;
 }

 /* 2025.10.15 반응형 추가 */
 @media (max-width: 768px) {

   .greeting-section {
     padding: 40px 20px !important;
   }

   .section-container {
     display: flex !important;
     flex-direction: column !important;
     gap: 40px !important;
     max-width: 100% !important;
   }

   .greeting-section .left {
     position: static !important;
     flex: none !important;
     margin: 22px 38px !important;
     display: flex !important;
     flex-direction: column !important;

   }

   .greeting-section h2 {
     font-size: 36px !important;
     font-weight: 900 !important;
     margin-bottom: 4px !important;
     line-height: 1.4 !important;
   }

   .intro {
     font-size: 18px !important;
     font-weight: 600 !important;
     line-height: 1.8 !important;
   }

   .right {
     flex: none !important;
     width: 100% !important;
   }

   .greeting-section .ceo-info {
     align-items: center !important;
     justify-content: center !important;
     gap: 24px !important;
     margin-bottom: 24px !important;
     margin-right: 0 !important;
     float: none !important;
   }

   .greeting-section .content p {
     font-size: 16px !important;
     line-height: 1.8 !important;
     text-align: left !important;
   }
 }`, "",{"version":3,"sources":["webpack://./static/css/company.css"],"names":[],"mappings":"CAAC,UAAU;CACV;GACE,aAAa;CACf;;CAEA;GACE,aAAa;GACb,SAAS;GACT,iBAAiB;GACjB,cAAc;CAChB;;CAEA,aAAa;CACb;GACE,OAAO;GACP,gBAAgB;GAChB,UAAU;GACV,sBAAsB;CACxB;;CAEA;GACE,eAAe;GACf,gBAAgB;GAChB,mBAAmB;CACrB;;CAEA;GACE,eAAe;GACf,gBAAgB;GAChB,gBAAgB;CAClB;;CAEA,iBAAiB;CACjB;GACE,OAAO;CACT;;CAEA;GACE,aAAa;GACb,SAAS;GACT,mBAAmB;GACnB,kBAAkB;GAClB,WAAW;;CAEb;;CAEA;GACE,aAAa;GACb,sBAAsB;GACtB,kBAAkB;GAClB,mBAAmB;CACrB;;CAEA;GACE,iBAAiB;GACjB,mBAAmB;GACnB,kBAAkB;;CAEpB;;CAEA;GACE,gBAAgB;GAChB,oBAAoB;GACpB,cAAc;GACd,cAAc;CAChB;;CAEA,WAAW;CACX;GACE,eAAe;GACf,gBAAgB;GAChB,mBAAmB;CACrB;;CAEA,sBAAsB;CACtB;;GAEE;KACE,6BAA6B;GAC/B;;GAEA;KACE,wBAAwB;KACxB,iCAAiC;KACjC,oBAAoB;KACpB,0BAA0B;GAC5B;;GAEA;KACE,2BAA2B;KAC3B,qBAAqB;KACrB,4BAA4B;KAC5B,wBAAwB;KACxB,iCAAiC;;GAEnC;;GAEA;KACE,0BAA0B;KAC1B,2BAA2B;KAC3B,6BAA6B;KAC7B,2BAA2B;GAC7B;;GAEA;KACE,0BAA0B;KAC1B,2BAA2B;KAC3B,2BAA2B;GAC7B;;GAEA;KACE,qBAAqB;KACrB,sBAAsB;GACxB;;GAEA;KACE,8BAA8B;KAC9B,kCAAkC;KAClC,oBAAoB;KACpB,8BAA8B;KAC9B,0BAA0B;KAC1B,sBAAsB;GACxB;;GAEA;KACE,0BAA0B;KAC1B,2BAA2B;KAC3B,2BAA2B;GAC7B;CACF","sourcesContent":[" /* 본문 섹션 */\n .greeting-section {\n   padding: 60px;\n }\n\n .section-container {\n   display: flex;\n   gap: 60px;\n   max-width: 1100px;\n   margin: 0 auto;\n }\n\n /* 왼쪽 (스티키) */\n .greeting-section .left {\n   flex: 1;\n   position: sticky;\n   top: 100px;\n   align-self: flex-start;\n }\n\n .greeting-section h2 {\n   font-size: 36px;\n   font-weight: 900;\n   margin-bottom: 20px;\n }\n\n .intro {\n   font-size: 18px;\n   font-weight: 600;\n   line-height: 1.8;\n }\n\n /* 오른쪽 (스크롤 내용) */\n .right {\n   flex: 2;\n }\n\n .greeting-section .ceo-info {\n   display: flex;\n   gap: 40px;\n   margin-bottom: 16px;\n   margin-right: 24px;\n   float: left;\n\n }\n\n .greeting-section .person {\n   display: flex;\n   flex-direction: column;\n   text-align: center;\n   align-items: center;\n }\n\n .greeting-section .person p {\n   font-weight: bold;\n   margin-bottom: 10px;\n   text-align: center;\n\n }\n\n .greeting-section .person img {\n   max-width: 150px;\n   border-radius: 100px;\n   display: block;\n   margin: 0 auto;\n }\n\n /* 본문 텍스트 */\n .greeting-section .content p {\n   font-size: 16px;\n   line-height: 1.9;\n   text-align: justify;\n }\n\n /* 2025.10.15 반응형 추가 */\n @media (max-width: 768px) {\n\n   .greeting-section {\n     padding: 40px 20px !important;\n   }\n\n   .section-container {\n     display: flex !important;\n     flex-direction: column !important;\n     gap: 40px !important;\n     max-width: 100% !important;\n   }\n\n   .greeting-section .left {\n     position: static !important;\n     flex: none !important;\n     margin: 22px 38px !important;\n     display: flex !important;\n     flex-direction: column !important;\n\n   }\n\n   .greeting-section h2 {\n     font-size: 36px !important;\n     font-weight: 900 !important;\n     margin-bottom: 4px !important;\n     line-height: 1.4 !important;\n   }\n\n   .intro {\n     font-size: 18px !important;\n     font-weight: 600 !important;\n     line-height: 1.8 !important;\n   }\n\n   .right {\n     flex: none !important;\n     width: 100% !important;\n   }\n\n   .greeting-section .ceo-info {\n     align-items: center !important;\n     justify-content: center !important;\n     gap: 24px !important;\n     margin-bottom: 24px !important;\n     margin-right: 0 !important;\n     float: none !important;\n   }\n\n   .greeting-section .content p {\n     font-size: 16px !important;\n     line-height: 1.8 !important;\n     text-align: left !important;\n   }\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
